import { useEffect } from 'react';

export const SPA_ROUTE_EVENTS = ['locationchange', 'single-spa:routing-event', 'popstate'];

export function useSpaRouteEvents(handler, options = {}) {
  const {
    enabled = true,
    runOnMount = true,
    events = SPA_ROUTE_EVENTS
  } = options;

  useEffect(() => {
    if (!enabled || typeof handler !== 'function') return;

    if (runOnMount) {
      handler();
    }

    events.forEach((eventName) => window.addEventListener(eventName, handler));

    return () => {
      events.forEach((eventName) => window.removeEventListener(eventName, handler));
    };
  }, [enabled, events, handler, runOnMount]);
}
